
import { ApiResponse, handleApiCall } from './api';
import { SHA512 } from 'crypto-js';
import { Admin, CreateNewAdminParams, EditAdminParams, AccessLogs } from 'src/interfaces/admin';

export async function resetPword(uid: string, newPassword: string, password?: string): Promise<ApiResponse<void>> {

    if (password && newPassword) {
        return await handleApiCall<void>('post', 'v2/admin/reset', {
            body: {
                uid,
                new_password: SHA512(newPassword).toString(),
                password: SHA512(password).toString()
        }});
    }
    else {
        return await handleApiCall<void>('post', 'v2/admin/reset', {
            body: {
                uid,
                new_password: SHA512(newPassword).toString()
            }
        });
    }
}

export async function getAdminList(): Promise<ApiResponse<Admin[]>> {

    return await handleApiCall<Admin[]>('get', 'v2/admin');
}

export async function getAdminProfile(adminUID: string): Promise<ApiResponse<Admin[]>> {

    return await handleApiCall<Admin[]>('get', 'v2/admin', { query: `?uid=${adminUID}` });
}

export async function getAdminAccessLogs(adminUID?: string): Promise<ApiResponse<AccessLogs[]>> {

    const query = adminUID ? `/access?uid=${adminUID}` : '/access';
    return await handleApiCall<AccessLogs[]>('get', 'v2/admin', { query });
}

export async function editTeamMembership(adminUID: string, teamList: string[]): Promise<ApiResponse<{ uid: string, message: string }>> {

    return await handleApiCall<{ uid: string, message: string }>('put', 'v2/admin/teams', { 
        body: { admin_uid: adminUID, team_list: teamList } });
}

export async function createAdmin(adminInfo: CreateNewAdminParams): Promise<ApiResponse<{ uid: string, message: string }>> {

    if (adminInfo.password) {
        adminInfo.password = SHA512(adminInfo.password).toString();
    }

    return await handleApiCall<{ uid: string, message: string }>('post', 'v2/admin', { body: adminInfo });
}

export async function deleteAdmins(adminUIDs: string[]): Promise<ApiResponse<void>> {

    const queryParams = Object.values(adminUIDs).map((uid) => `uid_array=${uid}`).join('&');
    return await handleApiCall<void>('delete', 'v2/admin', { query: `?${queryParams}` });
}

export async function blockAdmins(adminUIDs: string[]): Promise<ApiResponse<void>> {

    return await handleApiCall('put', 'v2/admin/block', { body: { uid_array: adminUIDs } });
}

export async function activateAdmins(adminUIDs: string[]): Promise<ApiResponse<void>> {

    return await handleApiCall('put', 'v2/admin/activate', { body: { uid_array: adminUIDs } });
}

export async function terminateAdmin(rawPassword?: string): Promise<ApiResponse<void>> {

    if (rawPassword) {
        const password = SHA512(rawPassword).toString();
        return await handleApiCall('delete', 'v2/admin/terminate', { query: `?password=${password}` });
    }
    return await handleApiCall('delete', 'v2/admin/terminate', {});
}

export async function editAdmin(adminProfile: EditAdminParams): Promise<ApiResponse<void>> {

    return await handleApiCall('put', `v2/admin`, { body: adminProfile });
}

